import type { MatchRule } from './matchRule';

// "Complements to 10": 3 needs 7, 6 needs 4, 5 needs 5. Trains the make-ten
// fact family — the foundation of fast mental addition. 0 maps to 0 so every
// enemy still has a single-digit answer.
export function makeComplementRule(total = 10): MatchRule {
  const answerFor = (value: number): number => (total - value) % 10;
  return {
    id: total === 10 ? 'complement' : `complement-${total}`,
    label: total === 10 ? 'Make Ten' : `Make ${total}`,
    instructions: `Hit each number with the digit that adds up to ${total}.`,
    answerFor,
    displayFor: (value) => String(value),
    matches: (input, value) => answerFor(value) === input,
  };
}

export const complementRule = makeComplementRule(10);
